<template>
  <JobStatusPill
    v-if="isHrisProfile"
    :status-text="isArchived ? 'Inactive' : 'Active'"
    :status-class="isArchived ? 'bg-red' : 'open'"
    :show-hover-effect="false"
  />
  <JobStatusPill
    v-else
    :status-text="isTemplate ? 'Template' : 'Draft'"
    :status-class="isTemplate ? 'template' : 'draft'"
    :show-hover-effect="false"
  />
</template>

<script setup>
import JobStatusPill from '@/components/editor/JobStatusPill.vue';

defineProps({
  isTemplate: { type: Boolean, default: false },
  isHrisProfile: { type: Boolean, default: false },
  isArchived: { type: Boolean, default: false },
});
</script>
